import { render } from "./SmsProcess.vue?vue&type=template&id=c2d80826"
import script from "./SmsProcess.vue?vue&type=script&lang=js"
export * from "./SmsProcess.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__